import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import classNames from "classnames"
import { Link } from "react-router"
import { default as headerMessages } from "../../messages/header"
import { default as sharedMessages } from "../../messages/index"
import { FormattedMessage } from "react-intl"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'
import CollectionImage from "../elements/CollectionImage";
import ResultsWithoutPagination from "../modules/ResultsWithoutPagination";

class Collections extends Component {
  static propTypes = {
    viewer: PropTypes.object.isRequired
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    const { resources_collections: collections } = this.props.viewer

    const headerImageResource =
      collections.length && "cover_image" in collections[0] ? collections[0].cover_image : null

    return (
      <main id="main" role="main" tabIndex={0}>
        {getStyleTag([
          'rich-page-header__content',
          'c-tabs__tab',
          'c-tabs--pagey__tab'
        ])}
        <div className="rich-page-header state-has-overlap" style={getStyles('rich-page-header')}>
          <CollectionImage
            images={headerImageResource}
            className="rich-page-header__bg"
          />
          <div className="rich-page-header__content mbm"
               style={getStyles('rich-page-header__content')}>
            <div className="row column">
              <h1 className="rich-page-header__title" style={getStyles('rich-page-header__title')}>
                <FormattedMessage {...headerMessages.collections} />
              </h1>
            </div>
          </div>
        </div>

        <div className={classNames("c-tabs c-tabs--pagey c-tabs-collections")}>
          <div className="row column" style={getStyles('c-tabs--pagey')}>
            <nav className="c-tabs__nav">
              <Link
                to="/featured-collections"
                className="c-tabs__tab"
                activeClassName="state-active"
                style={getStyles([
                  'c-tabs__tab',
                  'collections__c-tabs__tab'
                ])}
              >
                <FormattedMessage {...sharedMessages.featuredCollections} />
              </Link>
              <Link
                to="/collections"
                className="c-tabs__tab"
                activeClassName="state-active"
                style={getStyles([
                  'c-tabs__tab',
                  'collections__c-tabs__tab',
                  'c-tabs__tab__active'
                ])}
              >
                <FormattedMessage {...headerMessages.collections} />
              </Link>
              <Link
                to="/sets"
                className="c-tabs__tab"
                activeClassName="state-active"
                style={getStyles([
                  'c-tabs__tab',
                  'collections__c-tabs__tab'
                ])}
              >
                <FormattedMessage {...sharedMessages.communitySets} />
              </Link>
            </nav>
          </div>

          <ResultsWithoutPagination className="column" articleStyle="fluid" resources={collections} />
        </div>
      </main>
    )
  }

  groupToSize = (collections, size = 3) => {
    const res = collections.reduce(
      ({ grid, index }, collection) => {
        if (grid[index].length >= size) {
          index += 1
          grid[index] = []
        }
        grid[index].push(collection)

        return { grid, index }
      },
      { grid: [[]], index: 0 }
    )

    return res.grid
  }
}

export default Relay.createContainer(Collections, {
  initialVariables: {
    q: ""
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        resources_collections(search: $q) {
          id
          slug
          title
          description
          collected {
            total
          }
          cover_image {
            small {
              url
              width
              height
              mime_type
            }
            medium {
              url
              width
              height
              mime_type
            }
            large {
              url
              width
              height
              mime_type
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/Collections.js